import React from "react";
import { NAV } from "../lib/data";

export const Footer = () => {
  const go = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  return (
    <footer data-testid="site-footer" className="border-t border-line bg-ink">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-10 border-b border-line pb-12">
          <div>
            <img src="/logo.png" alt="Goose the Gander" className="h-20 w-20 object-contain mb-4" />
            <div className="font-serif text-4xl sm:text-5xl text-bone">Goose the Gander</div>
            <div className="font-mono text-[11px] uppercase tracking-[0.25em] text-brass mt-3">Discipline today. Freedom tomorrow.</div>
            <p className="text-mute mt-4 max-w-sm leading-relaxed">
              A proprietary trading firm. We back conviction with real capital — and share the upside with the traders who create it.
            </p>
          </div>
          <button
            data-testid="footer-apply-btn"
            onClick={() => go("#apply")}
            className="font-mono text-xs uppercase tracking-[0.2em] bg-brass text-ink px-7 py-4 hover:bg-bone transition-colors self-start"
          >
            Apply to trade
          </button>
        </div>

        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6 pt-8">
          <div className="flex flex-wrap gap-x-8 gap-y-3">
            {NAV.map((n) => (
              <button key={n.href} onClick={() => go(n.href)} className="font-mono text-[11px] uppercase tracking-[0.18em] text-mute hover:text-brass transition-colors">
                {n.label}
              </button>
            ))}
          </div>
          <div className="font-mono text-[11px] uppercase tracking-[0.18em] text-mute">
            © {new Date().getFullYear()} Goose the Gander · Est. 2026
          </div>
        </div>
      </div>
    </footer>
  );
};
